/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `draft` - 초안
 * `approved` - 승인됨
 * `generating` - 생성 중
 * `completed` - 완료
 * `rejected` - 거부됨
 * `failed` - 실패
 */
export type IdeaStatus = (typeof IdeaStatus)[keyof typeof IdeaStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IdeaStatus = {
  draft: "draft",
  approved: "approved",
  generating: "generating",
  completed: "completed",
  rejected: "rejected",
  failed: "failed",
} as const;
